import { renderButton } from 'BomdisoftComponents/buttons/render';
import { attributes, type HtmlValue, html, joinClasses } from 'BomdisoftComponents/html/index';
import { renderSidePanel } from 'BomdisoftComponents/side-panel/render';

export const DEFAULT_EDIT_DRAWER_WIDTH = 400;

const PANEL_INSET = 16;

export type BottomSheetOptions = {
  children?: HtmlValue;
  className?: string;
  flush?: boolean;
  label?: string;
  labelledBy?: string;
  testId?: string;
};

export type EditDrawerOptions = {
  children?: HtmlValue;
  closeLabel: string;
  closeTooltipId: string;
  hasSave?: boolean;
  open?: boolean;
  saveDisabled?: boolean;
  saveLabel?: string;
  testId?: string;
  title: HtmlValue;
  titleAdornment?: HtmlValue;
  width?: number;
};

export const renderBottomSheet = ({ children, className, flush, label, labelledBy, testId }: BottomSheetOptions) =>
  html`<dialog${attributes({ 'aria-label': label, 'aria-labelledby': labelledBy, class: joinClasses('bomdisoft-bottom-sheet', className), 'data-flush': flush, 'data-testid': testId })}><span${attributes({ class: 'bomdisoft-bottom-sheet-handle', 'data-testid': testId ? `${testId}-handle` : undefined })}><span aria-hidden="true" class="bomdisoft-bottom-sheet-grip"></span></span>${children}</dialog>`;

export const toEditDrawerSlot = (width = DEFAULT_EDIT_DRAWER_WIDTH) => {
  const slot = width + PANEL_INSET * 2;
  return { maxWidth: slot, minWidth: slot, width: slot };
};

export const renderEditDrawer = ({ children, closeLabel, closeTooltipId, hasSave = false, open = false, saveDisabled, saveLabel = 'Save', testId, title, titleAdornment, width = DEFAULT_EDIT_DRAWER_WIDTH }: EditDrawerOptions) =>
  renderSidePanel({
    children,
    closeLabel,
    closeTooltipId,
    footer: hasSave ? renderButton({ attributes: { 'data-testid': testId ? `${testId}-save` : undefined, disabled: saveDisabled }, children: saveLabel, variant: 'contained' }) : undefined,
    open,
    placement: 'docked',
    testId,
    title: titleAdornment === undefined ? title : html`<span class="bomdisoft-edit-drawer-title-group">${title}${titleAdornment}</span>`,
    width,
  });
